import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { VoceRegistro } from '@emacomfort/domain';
import { useFormato } from '@/app/formato';
import { Avviso, Card, Pagina, cx, stili } from '@/ui';
import { useSondaggio, useTecnico } from '../comune';

function mostraValore(v: string | null): string {
  if (v === null) return '—';
  try {
    const parsed: unknown = JSON.parse(v);
    if (typeof parsed === 'string' || typeof parsed === 'number' || typeof parsed === 'boolean') return String(parsed);
    if (Array.isArray(parsed)) return parsed.join(', ');
    if (parsed && typeof parsed === 'object') return Object.entries(parsed as Record<string, unknown>).map(([k, val]) => `${k}: ${String(val)}`).join(' · ');
  } catch {
    /* testo semplice */
  }
  return v;
}

export function RegistroPage() {
  const { t } = useTranslation();
  const f = useFormato();
  const { esegui } = useTecnico();
  const carica = useCallback(() => esegui((tec, sess) => tec.getRegistro(sess)), [esegui]);
  const { dati } = useSondaggio<VoceRegistro[]>(carica, 2000);
  const voci = dati ?? [];
  return (
    <Pagina titolo={t('tecnico.registro.titolo')} sottotitolo={t('tecnico.registro.sottotitolo')}>
      {voci.length === 0 && <Avviso tono="info">{t('tecnico.registro.vuoto')}</Avviso>}
      {voci.length > 0 && (
        <Card>
          <div className={stili.scorrevole}>
            <table className={stili.tabella}>
              <thead>
                <tr>
                  <th>{t('tecnico.registro.istante')}</th>
                  <th>{t('tecnico.registro.operatore')}</th>
                  <th>{t('tecnico.registro.azione')}</th>
                  <th>{t('tecnico.registro.oggetto')}</th>
                  <th>{t('tecnico.registro.prima')}</th>
                  <th>{t('tecnico.registro.dopo')}</th>
                </tr>
              </thead>
              <tbody>
                {voci.map((v) => (
                  <tr key={v.id}>
                    <td className={stili.mono}>{f.dataOra(v.ts)}</td>
                    <td>{v.operatore}</td>
                    <td>{t(`tecnico.registro.azioni.${v.azione}`, { defaultValue: v.azione })}</td>
                    <td className={stili.mono}>{v.oggetto}</td>
                    <td className={cx(stili.mono, stili.muto)}>{mostraValore(v.prima)}</td>
                    <td className={stili.mono}>{mostraValore(v.dopo)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </Pagina>
  );
}
